<template>
  <div class="booking-form__receiver">
    <div class="container-fluid">
      <div class="row">
        <div class="col customer-type">
          <div class="flex justify-between items-center">
            <div>
              <h3 class="label text-md">
                Receiver
                <tool-tip text="Recipient of the goods being shipped." />
              </h3>
            </div>
          </div>
          <div class="d-flex mt-3 mb-4">
            <label class="radio-label" for="business-customer">
              <input type="radio" id="business-customer" value="business" v-model="consignee.customerType" />
              Business Customer
              <span></span>
            </label>
            <label class="radio-label ml-4" for="private-customer">
              <input type="radio" id="private-customer" value="private" v-model="consignee.customerType" />
              Private Customer
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label for="name" class="label">Name</label>
            <input type="text" class="input" placeholder="Enter Name" v-model="consignee.contactName" />
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6" v-if="consignee.customerType == 'business'">
          <div class="input-wrapper">
            <label class="label">Contact Person</label>
            <input type="text" v-model="consignee.contactPerson" class="input" placeholder="Enter Contact Person" />
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6" v-if="consignee.customerType != 'business'">
          <div class="input-wrapper">
            <label class="label">Email</label>
            <input type="email" class="input" placeholder="Enter email" v-model="consignee.email" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6" v-if="consignee.customerType == 'business'">
          <div class="input-wrapper">
            <label class="label">Email</label>
            <input type="email" class="input" placeholder="Enter email" v-model="consignee.email" />
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Phone Number</label>
              <div class="flex">
                <label class="radio-label" for="mobile">
                  <input type="radio" id="mobile" value="mobile" v-model="phoneNumberType" />
                  Mobile
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="fixed">
                  <input type="radio" id="fixed" value="fixed" v-model="phoneNumberType" />
                  Fixed
                  <span></span>
                </label>
              </div>
            </div>
            <div class="">
              <vue-tel-input :preferredCountries="['Nigeria']" v-model="consignee.mobile"></vue-tel-input>
              <div v-if="isValidPhone && consignee.mobile.length > 0">
                <p class="text-red-600">
                  Phone number must be numeric values only
                </p>
              </div>
              <div v-if="isValidPhoneLength && consignee.mobile.length > 0">
                <p class="text-red-600">
                  Phone number must be 11 characters long
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6" v-if="consignee.customerType != 'business'">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Address</label>

              <div class="flex">
                <label class="radio-label" for="residential">
                  <input type="radio" id="residential" value="residential" v-model="addressType" />
                  Residential
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="business">
                  <input type="radio" id="business" value="business" v-model="addressType" />
                  Business
                  <span></span>
                </label>
              </div>
            </div>
            <!-- <vue-google-autocomplete id="map" ref="consigneeAddress" classname="input" placeholder="Enter address"
              v-on:placechanged="getAddress" :value="lAddress.name">
            </vue-google-autocomplete> -->
            <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails" :country="'ng'"
              placeholder="Enter Address" :value="lAddress && lAddress.name ? lAddress.name : ''" />
          </div>
        </div>
      </div>

      <div class="row" v-if="consignee.customerType == 'business'">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Address</label>

              <div class="flex">
                <label class="radio-label" for="residential">
                  <input type="radio" id="residential" value="residential" v-model="addressType" />
                  Residential
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="business">
                  <input type="radio" id="business" value="business" v-model="addressType" />
                  Business
                  <span></span>
                </label>
              </div>
            </div>
            <vue-google-autocomplete id="map" ref="consigneeAddress" classname="input" placeholder="Enter address"
              v-on:placechanged="getAddress">
            </vue-google-autocomplete>
          </div>
        </div>
      </div>

      <hr class="mt-3 mb-3" />

      <div class="flex justify-between">
        <p class="font-semibold">Delivery Info</p>
        <p class="text-xl">+</p>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12 col-md-12 col-lg-6 px-3">
          <p class="font-semibold">How do you want us to deliver your shipment?</p>
          <div class="mt-3">
            <div class="flex justify-between">
              <div class="flex">
                <label class="radio-label" for="pickup">
                  <input type="radio" name="shippingtype" id="pickup" value="pickup" v-model="shippingType" />
                  Receiver will pick from terminal
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="dropoff">
                  <input type="radio" id="dropoff" name="shippingtype" value="dropoff" v-model="shippingType" />
                  Deliver to receiver’s address
                  <span></span>
                </label>
              </div>
            </div>

            <div v-if="shippingType == 'dropoff'" class=""></div>

            <div v-if="shippingType == 'dropoff'" class="">
              <p>Date/Time</p>
              <el-date-picker v-model="deliveryDays" :style="{ width: '447px' }" class="w-full" type="date"
                placeholder="Select Preferred Pick-up date" format="yyyy/MM/dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper" style="width: 95%">
            <base-checkbox v-model="consignee.sendShippingUpdates" label="Share status updates with Receiver.." />
          </div>
        </div>
      </div>

      <div class="row" v-if="consignee.customerType == 'business'">
        <div class="col-sm-12 col-md-12 col-lg-12"></div>
      </div>

      <div class="button-wrapper">
        <p class="cursor-pointer underline" @click="$emit('back-one-form')">Back</p>
        <span class="mr-6">
          <base-button text="Continue" :loading="isLoading" @click="handleSubmit"
            :disabled="isValidPhone || isValidPhoneLength" />
        </span>
      </div>
    </div>
    <load-consignee-modal :show-modal="showLoadConsigneeModal" @form-loaded="formLoaded"
      @close-modal="showLoadConsigneeModal = false" @handleSubmit="handleExistingConsignee" />
  </div>
</template>

<script>
// import VueGoogleAutocomplete from "vue-google-autocomplete";
import LoadConsigneeModal from "../Modals/LoadConsigneeModal";

export default {
  name: "consignee-form",
  props: ["formNo"],
  components: {
    // VueGoogleAutocomplete,
    LoadConsigneeModal,
  },
  data() {
    return {
      consignee: {
        email: "",
        type: "",
        mobile: "",
        customerType: "private",
        country: "",
        zipCode: "",
        contactName: "",
        address: "",
        contactPerson: "",
        sendShippingUpdates: false,
        pickUp: null,
      },
      deliveryDays: null,
      shippingType: "pickup",
      address: {
        name: "",
        lat: 0.0,
        lng: 0.0,
      },
      addressType: "business",
      phoneNumberType: "mobile",
      countries: ["Nigeria"],
      isLoading: false,
      isDeleteModal: false,
      transactionId: "",
      hasState: true,
      showLoadConsigneeModal: false,
      hasCity: true,
      mustUpdate: false,
      errorMessage: "",
      terminalsExist: false,
      pickUpArray: [],
      shippingMethod: "",
    };
  },
  watch: {
    "consignee.customerType"(val) {
      if (val == "business") {
        this.addressType = "business";
      } else {
        this.addressType = "residential";
      }
    },
    isNewConsignee(val) {
      if (val) {
        this.consignee = {
          email: "",
          mobile: "",
          type: "delivery",
          customerType: "business",
          city: "",
          state: "",
          country: "",
          zipCode: "",
          contactName: "",
          address: {
            name: "",
            lat: 6.123,
            lng: 3.456,
          },
        };
      }
    },
    "consignee.mobile"(val) {
      if (val.length <= 11) {
        this.consignee.mobile = val;
      } else {
        // this.consignee.mobile = val.trim().substring(0, 12);
      }
    },
    "$store.state.bookingModule.lastCompletedFormNo"() {
      if (this.$store.state.bookingModule.lastCompletedFormNo == this.formNo) {
        if (this.$store.getters.consigneeInformation.id.length > 0) {
          this.consignee = { ...this.$store.getters.consigneeInformation };
        }
      }
    },
    consigneeDetails: {
      handler(val) {
        if (val && this.$store.getters.consigneeLocationPreselected) {
          this.consignee = { ...val };
          this.$refs.consigneeAddress.update(this.formatAddress(this.consignee.address));
        }
      },
      deep: true,
      immediate: true,
    },
    consignee: {
      handler: function () {
        this.mustUpdate = true;
      },
      // deep: true,
    },
    shippingType(val){
        let shippingmethod = val == "pickup" ? 'terminal' : 'door'
        this.$store.dispatch("set3PLShippingMethodEnd", shippingmethod);
        console.log("++++++++++++++++++++++++++++++++++", shippingmethod, val)
        this.$store.dispatch("saveBookingInformation", {
          property: "consigneeShipmentType",
          value: val,
        });
        if (this.shippingType == "pickup") {
          this.getTerminals();
        }
    },
  },
  computed: {
    customStyle() {
      return {
        width: '100%',
        padding: '8px 10px',
        borderRadius: '5px',
        border: '1px solid grey'
      }
    },
    isNewConsignee() {
      return this.$store.getters.isNewConsignee;
    },
    consolidationId() {
      return this.$store.getters.getShipConsolidationID;
    },
    consigneeDetails() {
      return this.$store.getters.consigneeInformation;
    },
    consigneeerDetails() {
      return this.$store.getters.shipperInformation;
    },
    shipperAdd() {
      return this.$store.getters.shipperInformation.address;
    },
    consigneeAdd() {
      return this.$store.getters.consigneeInformation.address;
    },
    isValidPhone() {
      let phone = this.consignee.mobile;
      var patt = /[a-z]+/i;

      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.consignee.mobile.replace(/\s+/g, "").length != 11
        ? true
        : false;
    },
  },
  mounted() {
    this.showLoadConsigneeModal = true;
    this.consignee.customerType = "private";

    if (this.$store.getters.getSavedQuote3Pl.id) {
      this.showLoadConsigneeModal = false;
      this.consignee.customerType = "private";

      this.consignee = { ...this.$store.getters.getSavedQuote3Pl?.consigneelocation };
      // this.$refs.consigneeAddress.update(this.formatAddress(this.consignee.address));

      this.address = this.consignee.address;

      this.getShippingRoute();
      this.getTerminals();

      delete this.consignee.userId;
      this.shippingType = '';
      delete this.consignee.updatedAt;
      delete this.consignee.createdAt;
      return
    }

    if (this.$store.getters.consigneeLocationPreselected) {
      this.consignee = { ...this.$store.getters.consigneeInformation };
      // this.$refs.consigneeAddress.update(this.formatAddress(this.consignee.address));

      this.address = this.consignee.address;

      this.getShippingRoute();
      this.getTerminals();

      delete this.consignee.userId;
      delete this.shippingType;
      delete this.consignee.updatedAt;
      delete this.consignee.createdAt;
    }
  },
  methods: {
    formLoaded() {
      // this.$emit("change-form");
    },

    handleExistingConsignee(consignee) {
      this.consignee = { ...consignee };
      this.$refs.consigneeAddress.update(this.formatAddress(this.consignee.address));

      this.address = this.consignee.address;

      this.getTerminals();
      this.getShippingRoute();

      this.mustUpdate = false;
    },

    async handleSubmit() {
      this.isLoading = true;
      this.errorMessage = "";
      await this.checkTerminals();

      if (this.terminalsExist) {
        if (this.consignee.id) {
          this.handleResponse(this.consignee);
        } else {
          this.submitConsigneeInformation();
        }
      } else {
        this.isLoading = false;
        this.generateToast(`${this.errorMessage}`, "error");
      }

      this.mustUpdate = false;
    },
    async checkTerminals() {
      let shipperAdd = this.$store.getters.shipperInformation.address;
      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        arrivalLocation: {
          lat: this.address.lat,
          lng: this.address.lng,
        },
        takeOffLocation: {
          lat: shipperAdd.lat,
          lng: shipperAdd.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);

        let takeOffArray = [];
        let pickUpArray = [];

        takeOffArray = response.data.data.takeOffLocation;
        pickUpArray = response.data.data.arrivalLocation;

        if (takeOffArray.length > 0 && pickUpArray.length == 0) {
          this.errorMessage =
            "Terminals does not exist for the selected address for the Sender Receiver. Please select another location with existing terminals before proceeding";
        } else if (takeOffArray.length == 0 && pickUpArray.length > 0) {
          this.errorMessage =
            "Terminals does not exist for the selected address for the Sender. Please select another location with existing terminals before proceeding";
        } else if (takeOffArray.length == 0 && pickUpArray.length == 0) {
          this.errorMessage =
            "Terminals does not exist for the selected address for the Sender and Receiver. Please select another location with existing terminals before proceeding";
        }

        if (takeOffArray.length > 0 && pickUpArray.length > 0) {
          this.terminalsExist = true;
        } else {
          this.terminalsExist = false;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async submitConsigneeInformation() {
      this.isLoading = true;

      if (this.consignee.address == "") {
        this.consignee.address = this.address;
      }

      delete this.consignee.id;

      try {
        const response = await this.$_submitConsigneeInformation(this.consignee);
        this.handleResponse(response.data.data.location);
      } catch (error) {
        this.isLoading = false;
        this.handleError(error);
      }

      this.isLoading = false;
    },
    handleResponse(location) {
      this.$store.dispatch("saveBookingInformation", {
        property: "consignee",
        value: location,
      });
      this.mustUpdate = false;
      this.$store.dispatch("saveDeliveryLocationId", location.id);
      this.$store.dispatch("saveLastCompletedFormNo", 2);
      this.createShippingId();
    },

    async createShippingId() {
      const payload = {
        payload: {
          shipperLocationId: this.$store.getters.shipperInformation.id,
          consigneeLocationId: this.$store.getters.consigneeInformation.id,
          orgId: this.$store.state.authentication.organizationId,
          paymentStatus: "Not paid",
          pickUp: this.consignee.pickUp,
          deliveryDays: this.deliveryDays,
          shippingServiceId: null,
          deliveryConfirmation: false,
          currentStep: 2,
        },
      };
      if (this.consolidationId) {
        payload.payload.consolidationId = this.consolidationId;
      }
      await this.$_createShippingId(payload)
        .then((response) => {
          this.$store.dispatch("saveShippingId", response.data.data.shipping.id);

          this.$store.dispatch("saveBookingInformation", {
            property: "shippingInformation",
            value: response.data.data.shipping,
          });

          this.getShippingMethod();
          this.getShippingRoute();

          this.$emit("change-form");
        })
        .catch((e) => {
          this.handleError(e);
        });
      this.isLoading = false;
    },
    viewLocationDetails(response) {
      const addressData = {
        route: response.formatted_address,
        latitude: response.geometry.location.lat(),
        longitude: response.geometry.location.lng()
      }
      this.getAddress(addressData)
    },
    getAddress(addressData) {
      this.address.name = addressData.route;
      this.address.lat = addressData.latitude;
      this.address.lng = addressData.longitude;
      this.consignee.country = this.countries[0];

      this.consignee.pickUp = "";

      this.getTerminals();
      this.getShippingRoute();
    },
    async getTerminals() {
      let consigneeAdd = this.address;

      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        arrivalLocation: {
          lat: consigneeAdd.lat,
          lng: consigneeAdd.lng,
        },
        takeOffLocation: {
          lat: 0,
          lng: 0,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);

        this.takeOffArray = response.data.data.takeOffLocation;
        this.pickUpArray = response.data.data.arrivalLocation;

        this.consignee.pickUp = this.pickUpArray[0].id;

        this.$store.dispatch("saveTakeOffTerminals", this.takeOffArray);
        this.$store.dispatch("savePickUpTerminals", this.pickUpArray);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getShippingRoute() {
      let sPayload = {
        lat: this.shipperAdd.lat,
        long: this.shipperAdd.lng,
      };
      let cPayload = {
        lat: this.address.lat,
        long: this.address.lng,
      };

      try {
        const shipperstate = this.shipperAdd.lat && await this.$_getStateNameWithDim(sPayload);
        const consigneestate = this.address.lat && await this.$_getStateNameWithDim(cPayload);

        if (shipperstate.data.state == consigneestate.data.state) {
          // console.log("intra-state");
          this.$store.dispatch("saveShippingRouteType", "intra-state");
        } else {
          // console.log("inter-state");
          this.$store.dispatch("saveShippingRouteType", "inter-state");
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    getShippingMethod() {
      let shipping = this.$store.state.bookingModule.newBooking.shipperShipmentType;

      // console.log(shipping);
      // console.log(this.consignee);

      if (shipping == "dropoff" && this.shippingType == "pickup") {
        this.shippingMethod = "terminal-to-terminal";
      } else if (shipping == "dropoff" && this.shippingType == "dropoff") {
        this.shippingMethod = "terminal-to-door";
      } else if (shipping == "pickup" && this.shippingType == "dropoff") {
        this.shippingMethod = "door-to-door";
      } else if (shipping == "pickup" && this.shippingType == "pickup") {
        this.shippingMethod = "door-to-terminal";
      } else {
        this.shippingMethod = "invalid-terminal";
      }

      this.$store.dispatch("saveBookingInformation", {
        property: "shippingMethod",
        value: this.shippingMethod,
      });

      // console.log(this.shippingMethod);
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__receiver {
  padding: 2rem 2.5rem;
}

.label {
  color: var(-primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input,
.vti__input,
.vue-tel-input {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  height: 2.65rem !important;
}

.input::placeholder {
  color: #bec4d5;
}

.customer-type {
  margin: 1rem 1.5rem;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

.customer-type h3 {
  font-size: 1.2rem;
}

.radio-label span::after {
  background: #bec4d5;
}

.error-div {
  color: red;
  font-size: 1.2rem;
}
</style>
